<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableRedisDate"
      style="width: 100.1%"
    >
      <template slot-scope="{ row, index }" slot="delete">
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            v-hasPermission="['elasticache:redisMonitor:delete']"
            @click="redisDelmodal = true"
            >{{ $t("alarms.common.delete") }}</Button
          >
        </span>
        <Button
          type="info"
          size="small"
          v-hasPermission="['elasticache:redisMonitor:getAwsCacheDetailById']"
          @click="rowClick(row)"
          >{{ $t("alarms.common.details") }}</Button
        >
      </template>
    </Table>
    <!-- 删除模式框 -->
    <Modal v-model="redisDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color: #f60; text-align: center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align: center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ deleteName }}
          {{ $t("alarms.common.allWarningRules") }} ？
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeRedis()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableRedisVue = {};
export default {
  name: "TableRedis",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      redisDelmodal: false,
      isDisable: false,
      modal_loading: false,
      companyId: "",
      cacheClusterId: "",
      deleteName: "",
      columns: [
        {
          title: this.$t("alarms.redis.cacheClusterId"),
          key: "cacheClusterId"
        },
        {
          title: this.$t("alarms.instance.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("alarms.instance.accountType"),
          key: "accountTypeName"
        },
        {
          title: "集群名称",
          key: "replicationGroupIdString"
        },
        {
          title: "缓存引擎",
          key: "cacheEngineName"
        },
        {
          title: "节点类型",
          key: "cacheNodeType"
        },
        {
          title: "状态",
          key: "cacheClusterStatusName"
        },
        {
          title: "区域",
          key: "region"
        },
        {
          title: this.$t("common.operation"),
          slot: "delete"
        }
      ],
      tableRedisDate: []
    };
  },
  beforeCreate: function() {
    tableRedisVue = this;
  },
  created() {
    eventBus.$on("companyId", function(val) {
      tableRedisVue.companyId = val;
    });
    eventBus.$on("cacheClusterId", function(val) {
      tableRedisVue.cacheClusterId = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableRedisVue.getData();
    },
    // 分页显示数据
    /****************************************************/
    getData: function() {
      //列表分页
      this.$api.awsCache
        .page({
          pageNum: this.current,
          pageSize: this.pageSize,
          companyId: tableRedisVue.companyId,
          cacheEngine: 1,
          cacheClusterId: tableRedisVue.cacheClusterId
        })
        .then(res => {
          this.tableRedisDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableRedisVue.getData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableRedisVue.getData();
    },
    // 销毁
    beforeDestroy: function() {
      eventBus.$off("companyId");
      eventBus.$off("cacheClusterId");
    },
    // 删除
    /****************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.deleteName = this.tableRedisDate[index].cacheClusterId;
    },
    removeRedis: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //删除
      this.$api.awsCache
        .delete("id", this.tableRedisDate[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableRedisVue.getData();
            this.isDisable = false;
            this.modal_loading = false;
            this.redisDelmodal = false;
            this.$Message.success("删除成功");
          }, 1000);
        });
    },
    // 单击行
    /****************************************************/
    rowClick: function(row) {
      this.$router.push({
        path: "/elasticache/redisDetail/",
        query: {
          id: row.id,
          accountId: row.accountId,
          cacheClusterId: row.cacheClusterId,
          region: row.region,
          accountTypeName: row.accountTypeName,
          accountName: row.accountName,
          instanceId: row.cacheClusterId,
          type: row.accountType
        }
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/elasticache/redis/TableRedis.vue